import { type FloatingHoverType } from '@/defs/floating'

import { FloatingArrow } from '../../common/FloatingArrow/FloatingArrow'
import { FloatingHoverRoot } from '../../common/FloatingHoverRoot/FloatingHoverRoot'
import { FloatingBox } from '../../FloatingBox/FloatingBox'

export const FloatingHoverDesktop = ({
  children,
  ignoreScopes,
  isClickable,
  placement,
  ...rest
}: FloatingHoverType) => (
  <FloatingHoverRoot ignoreScopes={ignoreScopes} isClickable={isClickable} placement={placement} trigger={children}>
    <FloatingArrow type='hover' />
    <FloatingBox {...rest} />
  </FloatingHoverRoot>
)
